module.exports = __webpack_public_path__ + "912ba0b51ca6e24c10595c439e343586.svg";